import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';

const cyPrefix = 'containers_select_country_and_platform_container';

const ids = addCyPrefixToIDs(cyPrefix, {
  BTN_SUBMIT: 'BTN_SUBMIT',
  BTN_SKIP: 'BTN_SKIP',
});

export const CY_PRODUCT_TO_CONTAINER_IDS_MAP = addCyPrefixToIDs(cyPrefix, {
  kco: 'SELECT_KCO',
  'kp-pay-now': 'SELECT_KP_PAY_NOW',
  'kp-pay-later': 'SELECT_KP_PAY_LATER',
  'kp-slice-it': 'SELECT_KP_SLICE_IT',
  'kp-slice-it-in-4': 'SELECT_KP_SLICE_IT_IN_4',
  kco_one: 'SELECT_KCO_ONE',
  kp_one: 'SELECT_KP_ONE',
});

export const CY_PRODUCT_IS_SELECTED_ATTRIBUTE = 'data-is-selected';

/**
 * We are exporting the IDS this way to help IDEs' code completion
 */
export const CY_MERCHANT_SIGNUP_PRODUCTS_CONTAINER_IDS = ids;
